import React, { useMemo } from "react";
import { files } from "../configs";
import "./SurveySelectNew.scss";

const SurveySelectFour = ({
  id,
  content,
  setAnswersList,
  answersList,
  showImg,
  isSoleQuestion,
  submit,
}) => {
  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === id),
    [answersList, id]
  );

  const answer = useMemo(
    () => (answerIdx >= 0 ? answersList[answerIdx].answers[0].degree : null),
    [answerIdx, answersList]
  );

  const saveAnswer = (degree) => {
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      let newScreenAnswersList = answersList;
      newScreenAnswersList[answerIdx] = {
        answers: [
          {
            degree: degree,
          },
        ],
        questionId: id,
      };

      setAnswersList([...newScreenAnswersList]);
    }
  };

  return (
    <div className="survey-select-indiv">
      <p className="survey-q">{content}</p>
      <div className="survey-select-inner">
        <ul className="list">
          <li className="list__item">
            {showImg ? (
              <img
                src={files + "/never.svg"}
                alt="전혀 아니다"
                className="ans-img"
              />
            ) : null}
            <p className="radio-top">전혀 아니다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-1`}
              value={1}
              onChange={() => {
                saveAnswer(1);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              checked={answer === 1 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-1`}
              id={`${id}-label-1`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            {showImg ? (
              <img
                src={files + "/sometimes.svg"}
                alt="가끔 그렇다"
                className="ans-img"
              />
            ) : null}
            <p className="radio-top">가끔 그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-2`}
              value={2}
              onChange={() => {
                saveAnswer(2);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              checked={answer === 2 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-2`}
              id={`${id}-label-2`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            {showImg ? (
              <img
                src={files + "/very_much.svg"}
                alt="매우 그렇다"
                className="ans-img"
              />
            ) : null}
            <p className="radio-top">매우 그렇다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-3`}
              value={3}
              onChange={() => {
                saveAnswer(3);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              checked={answer === 3 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-3`}
              id={`${id}-label-3`}
              className="label"
            ></label>
          </li>
          <li className="list__item">
            {showImg ? (
              <img
                src={files + "/dontknow.svg"}
                alt="모르겠음"
                className="ans-img"
              />
            ) : null}
            <p className="radio-top">모르겠다</p>
            <input
              type="radio"
              className="radio-btn"
              name={`${id}-choice`}
              id={`${id}-opt-4`}
              value={4}
              onChange={() => {
                saveAnswer(4);
                if (isSoleQuestion) {
                  submit();
                }
              }}
              checked={answer === 4 ? true : false}
            />
            <label
              htmlFor={`${id}-opt-4`}
              id={`${id}-label-4`}
              className="label"
            ></label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SurveySelectFour;
